interface IconProps {
  className?: string;
}

export default function EssayIcon({ className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 20H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.377 3.62173C16.775 3.22364 17.315 3 17.878 3C18.4409 3 18.9809 3.22364 19.379 3.62173C19.777 4.01982 20.0007 4.55975 20.0007 5.12273C20.0007 5.68572 19.777 6.22564 19.379 6.62373L7.36895 18.6347C7.13105 18.8726 6.83698 19.0467 6.51395 19.1407L3.64195 19.9787C3.5559 20.0038 3.46469 20.0053 3.37786 19.9831C3.29103 19.9608 3.21178 19.9157 3.1484 19.8523C3.08502 19.7889 3.03984 19.7097 3.0176 19.6228C2.99535 19.536 2.99686 19.4448 3.02195 19.3587L3.85995 16.4867C3.95417 16.1641 4.1282 15.8704 4.36595 15.6327L16.377 3.62173Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
